import { statusInfo } from "../../../utils/solicitacoes/statusConfig";

export default function StatusBadge({ status }) {
    const { label, className } = statusInfo(status);
    return (
        <span className={`inline-flex rounded-full px-2 py-0.5 text-[10px] font-semibold whitespace-nowrap ${className}`}>
            {label}
        </span>
    );
}
